import { headerBgPosition } from './HeaderBgStore.js';

export const updateHeaderBgPosition = (value) => headerBgPosition.update(oldValue => value);
